import React from 'react'
import { css } from '@emotion/css'
import { Vulnerability } from '../../../../components/shared'
import { CvssScoringType } from '../../helpers/ui-interfaces'
import { shouldUseCvss3 } from '../../helpers/cvssUtils'
import { Link } from '@contrast-security-inc/design-system-typography'

interface Props {
  vulnerability: Vulnerability
  setIsModalOpen?: React.Dispatch<boolean>
  setModalVulnerability?: React.Dispatch<
    React.SetStateAction<Vulnerability | undefined>
  >
  cvssScoringType?: CvssScoringType
}

export const LibraryVulnerabilityTooltipEntry = ({
  vulnerability,
  setModalVulnerability,
  setIsModalOpen,
  cvssScoringType
}: Props) => {
  return (
    <div
      className={css`
        font-size: 14px;
      `}
      key={vulnerability.name}
    >
      <Link
        onClick={() => {
          if (setModalVulnerability && setIsModalOpen) {
            setModalVulnerability(vulnerability)
            setIsModalOpen(true)
          }
        }}
      >
        {vulnerability.name}
      </Link>
      {vulnerability.hasCve && (
        <span
          className={css`
            padding-left: 5px;
          `}
        >
          {` ${
            shouldUseCvss3(vulnerability, cvssScoringType)
              ? vulnerability.cvss3SeverityValue
              : vulnerability.severityValue
          }`}
        </span>
      )}
    </div>
  )
}
